import React, { Fragment } from 'react';
import { Spinner } from 'shared/components/Spinner/index.js';
import { cs } from 'shared/utils/classnames';

export function ActionButton ({
  id,
  disabled,
  working,
  label,
  workingLabel,
  type,
  onClick
} : {
  id?: string,
  disabled?: boolean,
  working?: boolean,
  label: string,
  workingLabel?: string,
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"],
  onClick?: React.DOMAttributes<HTMLButtonElement>["onClick"]
}) {
  const className = cs('flex justify-center items-center gap-2 bg-violet-600 text-white rounded p-2 w-full font-bold', {
    'opacity-50': disabled
  });
  return (
    <button
      id={id}
      type={type}
      className={className}
      disabled={disabled}
      onClick={onClick}
    >
      {working ? <Fragment> <Spinner /> {workingLabel || label} </Fragment> : label}
    </button>
  );
}
